import { renderStatusItem } from './statusUtils';

const status = value => renderStatusItem(value);

export default status;
